import React, { Component } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";


import Login from "./components/screen/login/login.component";
import Dashboard from "./components/screen/dashboard/dashboard.component";

import MasterBusinessEntity from "./components/screen/business-entity/business-entity.component";
import VerifyDealer from "./components/screen/business-entity/verify-dealer.component";
import MasterVehicleBrand from "./components/screen/vehicle-brand/MasterVehicleBrand";
import MasterVehicleModel from "./components/screen/vehicle-model/MasterVehicleModel";
import MasterVehicleVariant from "./components/screen/vehicle-variant/MasterVehicleVariant";
import MasterVehiclePart from "./components/screen/vehicle-part/MasterVehiclePart";
import MasterVehiclePartType from "./components/screen/vehicle-part/MasterVehiclePartType";

import ImportVehicleModel from "./components/screen/vehicle-model/ImportVehicleModel";
import ImportVehiclePart from "./components/screen/vehicle-part/ImportVehiclePart";
import ImportVehiclePartPrice from "./components/screen/vehicle-part/ImportVehiclePartPrice";

// import ImportVehicleVariant from "./components/screen/vehicle-variant/import-vehicle-variant.component";
// import LaunchVariant from "./components/screen/vehicle-variant/launch-vehicle-variant.component";
import PrivateRoute from "./PrivateRoute";

class App extends Component {

  render() {
    return (
      <BrowserRouter>
        <Switch>
          <PrivateRoute exact path="/" component={Dashboard} />
          <Route exact path="/login" component={Login} />
          <PrivateRoute exact path="/dashboard" component={Dashboard} />
          <PrivateRoute exact path="/master/business-entity" component={MasterBusinessEntity} />
          <PrivateRoute exact path="/business-entity/verify-dealer" component={VerifyDealer} />
          <PrivateRoute exact path="/master/vehicle-brand" component={MasterVehicleBrand} />
          <PrivateRoute exact path="/master/vehicle-model" component={MasterVehicleModel} />
          <PrivateRoute exact path="/master/vehicle-variant" component={MasterVehicleVariant} />
          <PrivateRoute exact path="/master/vehicle-part-type" component={MasterVehiclePartType} />
          <PrivateRoute exact path="/master/vehicle-part" component={MasterVehiclePart} />
          <PrivateRoute exact path="/import/vehicle-model" component={ImportVehicleModel} />
          <PrivateRoute exact path="/import/vehicle-part" component={ImportVehiclePart} />
          <PrivateRoute exact path="/import/vehicle-part-price" component={ImportVehiclePartPrice} />
          {/* <PrivateRoute exact path="/import/vehicle-variant" component={ImportVehicleVariant} /> */}
          {/* <PrivateRoute exact path="/launch/vehicle-variant" component={LaunchVariant} /> */}
        </Switch>
      </BrowserRouter>
    );
  }
}

export default App;